module.exports = __webpack_public_path__ + "static/media/NewBanner2.198911fe.png";